import React, { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import {  Button } from "@mui/material";
import { makeStyles } from "@mui/styles";

import { Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CustomModal } from "../../../components";
import { useMediaQuery } from "@mui/material";

const customStyle = makeStyles({
  camera: {
    display: "flex",
    flexDirection: "column",
  },
  cameraContainer: {
    gap: "10px",
    display: "flex",
    minWidth: "650px",
  },
  addedItemContainer: {
    gap: "10px",
    margin: "15px 0px",
    display: "flex",
    flexDirection: "column",
    maxHeight: "115px",
    overflowY: "scroll",
    overflowX: "hidden",
  },
  formInput: {
    padding: "16px",
    border: "1px solid #ccc",
    borderRadius: "4px",
    fontSize: "18px",
  },
  "@media (max-width: 390px)": {
    camera: {
      flexDirection: "column",
    },
    cameraContainer: {
      gap: "5px",
      minWidth: "250px",
    },
    addedItemContainer: {
      gap: "5px",
      margin: "5px 0px",
      maxHeight: "115px",
    },
    formInput: {
      fontSize: "18px",
    },
  },
});

const UpdateModal = (props) => {
  const {
    isModalOpen,
    isLoading,
    onClose,
    currentImages,
    menuItems,
    addedItems,
    setAddedItems,
    handleAddItem,
    handleDeleteItem,
    onChangeValue,
    handleSubmit,
    validationErrors,
    submitLoading,
    currentImagesfirst,
    handleNothing,
  } = props;

  const classes = customStyle();
  const isPhone = useMediaQuery("(max-width: 390px)");
  const [anchorEls, setAnchorEls] = useState([]);

  useEffect(() => {
    setAnchorEls(Array.from({ length: addedItems.length }, () => null));
  }, [addedItems.length]);

  const handleMenuOpen = (event, index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = event.currentTarget;
    setAnchorEls(newAnchorEls);
  };

  const handleMenuClose = (index) => {
    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
  };

  const onChangeMenuItem = (menuItem, id, index) => {
    setAddedItems((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, selectedItem: menuItem } : item
      )
    );

    const newAnchorEls = [...anchorEls];
    newAnchorEls[index] = null;
    setAnchorEls(newAnchorEls);
  };

  const isValidInput = (id) =>
    validationErrors.some((error) => error.id === id);

  return (
    <CustomModal
      heading={"Update Transaction"}
      open={isModalOpen}
      onClose={onClose}
      width={isLoading ? "650px" : "auto"}
      isFetching={isLoading}
      hideSubmitButton={!currentImages || Object.keys(currentImages).length === 0}
      onSubmit={handleSubmit}
      showLoading={submitLoading}
    >
      <div className="flex-direction-column">
        {/* Camera Image Sections */}
        <div className={classes.cameraContainer} style={{ height: isPhone ? "130px" : "250px", marginTop: isPhone ? "-15px" : "-25px" }}>
          {currentImagesfirst &&
            Object.keys(currentImagesfirst).map((cameraNum) => (
              <div className={classes.camera} key={cameraNum}>
                <img
                  style={{
                    height: isPhone ? "80px" : "170px",
                    width: isPhone ? "105px" : "350px",
                  }}
                  src={currentImagesfirst[cameraNum].imageUrl}
                  alt={`Camera ${cameraNum}`}
                />
                <b>
                  <span style={{ fontSize: isPhone ? "4.5px" : "16px" }}>
                    Camera : {currentImagesfirst[cameraNum].imageName}
                  </span>
                </b>
              </div>
            ))}
        </div>

        <div className={classes.cameraContainer} style={{ height: "100px" }}>
          {currentImages &&
            Object.keys(currentImages).map((cameraNum) => (
              <div className={classes.camera} key={cameraNum}>
                <img
                  style={{
                    height: isPhone ? "80px" : "170px",
                    width: isPhone ? "105px" : "350px",
                    marginTop: isPhone ? "-20px" : "-30px",
                  }}
                  src={currentImages[cameraNum].imageUrl}
                  alt={`Camera ${cameraNum}`}
                />
                <b>
                  <span style={{ fontSize: isPhone ? "4.5px" : "16px" }}>
                    Camera : {currentImages[cameraNum].imageName}
                  </span>
                </b>
              </div>
            ))}
        </div>

        {/* Added Items Section */}
        <div className={classes.addedItemContainer} style={{ marginTop: isPhone ? "-60px" : "20px",marginLeft:"-170px" }}>
          {addedItems.map((item, index) => (
            <div
              className="flex gap-10 align-items-center"
              key={item.id}
              style={{ marginLeft: "170px", marginTop: "50px" }}
            >
              <Button
                aria-controls={`dropdown-menu-${index}`}
                aria-haspopup="true"
                onClick={(event) => handleMenuOpen(event, index)}
                variant="contained"
                color="primary"
                style={{
                  textTransform: "none",
                  fontSize: isPhone ? "8px" : "16px",
                  height: "54px",
                }}
                endIcon={<KeyboardArrowDownIcon />}
              >
                {item.selectedItem?.productName || "Select Product"}
              </Button>
              <Menu
                id={`dropdown-menu-${index}`}
                anchorEl={anchorEls[index]}
                keepMounted
                open={Boolean(anchorEls[index])}
                onClose={() => handleMenuClose(index)}
                style={{ zIndex: 1500 }}
              >
                {menuItems.map((menuItem, i) => (
                  <MenuItem
                    key={i}
                    onClick={() => onChangeMenuItem(menuItem, item.id, index)}
                  >
                    {menuItem.productName}
                  </MenuItem>
                ))}
              </Menu>

              <input
                className={`${classes.formInput} ${isValidInput(item.id) ? "error-input-color" : ""}`}
                type="number"
                placeholder="Enter Number of Quantities"
                value={item.quantity}
                onChange={(e) => onChangeValue(e.target.value, item.id)}
              />
              {isValidInput(item.id) && <span className="font-size-12">Must be greater than 0</span>}

              {index > 0 && (
                <Button
                  variant="contained"
                  color="secondary"
                  onClick={() => handleDeleteItem(item.id)}
                  style={{
                    fontSize: isPhone ? "8px" : "16px",
                    height: "54px",
                    marginLeft: isPhone ? "-225px" : "0px",
                  }}
                >
                  Delete
                </Button>
              )}
            </div>
          ))}
        </div>

        {/* Add Item & Nothing Bought Buttons */}
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginTop: isPhone ? "-60px" : "20px", marginLeft: "00px" }}>
          <Button
            variant="contained"
            style={{
              backgroundColor: "#FF5722",
              color: "white",
              padding: "8px 16px",
              fontSize: isPhone ? "10px" : "14px",
              borderRadius: "8px",
            }}
            onClick={handleAddItem}
          >
            + Add Item
          </Button>

          <Button
            variant="contained"
            style={{
              backgroundColor: "#f50057",
              color: "white",
              padding: "8px 16px",
              fontSize: isPhone ? "10px" : "14px",
              borderRadius: "8px",
              marginLeft:"30px"
            }}
            onClick={handleNothing}
          >
            Nothing Bought
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default UpdateModal;
